import HeaderContents from '../../components/organism/headers/HeaderContents.vue'
export default {
  components: { HeaderContents }
}
